import { PlusOutlined, VideoCameraOutlined } from '@ant-design/icons';
import { Button, Card, Col, Modal, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import AddRestTarif from './AddRestTarif';
import api from '../../../../api/axios';

function ServiceTarrifs({ serviceId, simple = false }) {
    const [openAdd, setOpenAdd] = useState(false)
    const [tariffs, setTariffs] = useState([])

    const loadTariffs = () => {
        api.get(`/service-tariffs/service/${serviceId}`)
            .then(res => {
                setTariffs(res.data.data)
            })
            .catch(err => {
                console.log(err)
            })
    }

    useEffect(() => {
        loadTariffs()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [serviceId])

    return (
        <>
            <Modal title="Tarif qo'shish" open={openAdd} onCancel={() => setOpenAdd(false)} footer={null} width={800} destroyOnHidden>
                <AddRestTarif serviceId={serviceId} simple={simple} onSuccess={loadTariffs} onClose={() => setOpenAdd(false)} />
            </Modal>
            <div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <h3>Tariflar</h3>
                    <Button icon={<PlusOutlined />} size='medium' type='primary' onClick={() => setOpenAdd(true)} >Qo'shish</Button>
                </div>
                <Row gutter={[16, 16]}>
                    {tariffs.length > 0 ? tariffs.map(tariff => (
                        <Col key={tariff.id} xs={24} sm={12} lg={8}>
                            <Card
                                hoverable
                                title={tariff.name}
                                bordered
                                extra={<span style={{ fontWeight: 600 }}>{Number(tariff.price).toLocaleString()} so'm</span>}
                            >
                                {tariff.image && (
                                    <div style={{ marginBottom: 12, textAlign: 'center' }}>
                                        <img
                                            alt={tariff.name}
                                            src={process.env.REACT_APP_URL + (tariff.image.startsWith('http') ? tariff.image : `${tariff.image}`)}
                                            style={{ width: '100%', maxHeight: 200, objectFit: 'cover', borderRadius: 8 }}
                                        />
                                    </div>
                                )}
                                {tariff.video_url && (
                                    <p style={{ position: 'absolute', top: 90, right: 30 }}>
                                        <a href={tariff.video_url} target="_blank" rel="noreferrer">
                                            <Button type="primary" icon={<VideoCameraOutlined />} style={{ padding: 0, fontSize: 20 }} shape="circle" size='large'  />
                                        </a>
                                    </p>
                                )}
                                {tariff.note && <p style={{ marginBottom: 12 }}><strong>Izoh:</strong> {tariff.note}</p>}
                                {tariff.foods && tariff.foods.length > 0 && (
                                    <div style={{ marginBottom: 12 }}>
                                        <p style={{ marginBottom: 6, fontWeight: 600 }}>Ovqatlar</p>
                                        <ul style={{ paddingLeft: 20, marginBottom: 0 }}>
                                            {tariff.foods.map(food => (
                                                <li key={food.pivot_id}>
                                                    {food.name} - {food.quantity} ta ({Number(food.price).toLocaleString()} so'm)
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                                {tariff.halls && tariff.halls.length > 0 && (
                                    <div>
                                        <p style={{ marginBottom: 6, fontWeight: 600 }}>Zalllar</p>
                                        <ul style={{ paddingLeft: 20, marginBottom: 0 }}>
                                            {tariff.halls.map(hall => (
                                                <li key={hall.pivot_id}>
                                                    {hall.name}: {hall.places} o'rin, {hall.area} m²
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </Card>
                        </Col>
                    )) : (
                        <Col span={24}>
                            <Card>Hozircha tarif topilmadi.</Card>
                        </Col>
                    )}
                </Row>
            </div>
        </>
    );
}

export default ServiceTarrifs;